import axiosInstance from "../configs/axios";
import { route } from "ziggy-js";
import { trans } from "../i18n/i18n";

/**
 * Sends an API key request to the backend.
 *
 * @param {URLSearchParams} data - The form data as URLSearchParams.
 * @returns {Promise<Object>} - The response data.
 */
export async function requestApiKey(data) {
    return (await axiosInstance.post(route("jsapi.requestApiKeyPost"), data, {
        toastMsg: trans("An error occurred while submitting the API key form. Please try again later."),
    })).data;
}
